import getQueryStringParams from './QueryString';

export const cookie = function (name, value, options) {
    if (typeof value != 'undefined') { // name and value given, set cookie
        options = options || {};
        
        if (value === null) {
            value = '';
            options.expires = -1;
        }
        var expires = '';
        if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
            var date;
            if (typeof options.expires == 'number') {
                date = new Date();
                date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
            } else {
                date = options.expires;
            }
            expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
        }
        // CAUTION: Needed to parenthesize options.path and options.domain
        // in the following expressions, otherwise they evaluate to undefined
        // in the packed version for some reason...
        var path = options.path ? '; path=' + (options.path) : '';
        var domain = options.domain ? '; domain=' + (options.domain) : '';
        var secure = options.secure ? '; secure' : '';
        document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
    } else { // only name given, get cookie
        var cookieValue = null;
        if (document.cookie && document.cookie != '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim();
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) == (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
};

const userSessionCookieName = 'mcUserSessionId';
const notToMonitorCookieName = 'notMonitoring';
// Event item model constructor
export function EventItem(timestamp, eventType, itemId) {
    this.timestamp = timestamp;
    this.eventType = eventType;
    this.itemId = itemId;
    this.pageUrl = CurrentUserSession.pageUrl;
    this.userId = CurrentUserSession.userId;
    this.sessionId = cookie(userSessionCookieName);
    this.pageId = CurrentUserSession.pageId;
    this.iniframe = window.self !== window.top;
}

function MapItem(x, y, width, height, timestamp, eventType) {
    this.timestamp = timestamp;
    this.eventType = eventType;
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.pageUrl = CurrentUserSession.pageUrl;
    this.userId = CurrentUserSession.userId;
    this.sessionId = cookie(userSessionCookieName);
    this.pageId = CurrentUserSession.pageId;
}

function ScrollPositionItem(percentage, eventType) {
    this.percentage = percentage;
    this.pageUrl = CurrentUserSession.pageUrl;
    this.userId = CurrentUserSession.userId;
    this.sessionId = cookie(userSessionCookieName);
    this.eventType = eventType;
    this.pageId = CurrentUserSession.pageId;
}

const CacheKeys = {
    impressionsListCacheKey: 'impressionsList',
    hoversListCacheKey: 'hoversList',
    clicksListCacheKey: 'clicksList',
    errorLog: 'errorLog',
    clickMap: 'clickMap',
    heatMap: 'heatMap',
    scrollPosition: 'scrollPosition'
};

export const EventType = {
    click: 'click',
    hover: 'hover',
    impression: 'impression',
    errorReport: 'errorReport',
    heatMap: 'heatMap',
    clickMap: 'clickMap',
    scrollPosition: 'scrollPosition'
};

// Current session object 
const CurrentUserSession = {
    userId: '',
    pageUrl: '',
    sessionId: '',
    visitorId: '',
    pageId: ''
};

export const Logger = {
    settings: {
        debug: true,
        sessionTTL: 86400, // day
        currentSessionId: ''
    },
    init: function () {
        var $this = this;
        // $this.startLogErrors();
    },
    sendLog: function (cacheKey) {
        var $this = this;
        var dataToSend = $this.getLocalData(cacheKey);

    },
    saveLocal: function (newEvent, cacheKey) {
        if (cookie(userSessionCookieName)) {
            var currentCollection = store.get(cacheKey);
            if (typeof currentCollection != 'undefined' && currentCollection !== null) {
                currentCollection.push(newEvent);
            } else {
                currentCollection = [];
                currentCollection.push(newEvent)
            }
            store.set(cacheKey, currentCollection);
        }
    },
    clearLocalLog: function (cacheKey) {
        store.set(cacheKey, null);
    },
    getQuerystring: function (name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));

    },
    startLogErrors: function () {
        if (cookie(userSessionCookieName)) {
            window.onerror = function (message, file, line) {
                var currentEventItem = new EventItem(Date.now(), EventType.errorReport, JSON.stringify({
                    message: message,
                    file: file,
                    line: line
                }));
                Logger.saveLocal(currentEventItem, CacheKeys.errorLog);
                Logger.sendLog(CacheKeys.errorLog);
            };
        }
    },
    setCurrentSession: function (userData) {
        var $this = this, sessionId, userId, sessionCreated;
        sessionId = $this.getQuerystring('sid');
        sessionCreated = $this.getQuerystring('sc');
        if (sessionCreated) {
            if (!$this.isValidSession(sessionCreated)) {
                sessionId = $this.getUUID();
            }
        }
        if (typeof userData == 'object') {
            if (typeof userData.sessionId != 'undefined' && !sessionId) {
                sessionId = userData.sessionId;
            }
            if (typeof userData != 'undefined') {
                userId = userData.userId;
            }
        }

        if (!sessionId) {
            sessionId = $this.getUUID();
        }

        if ($this.toMonitor()) {
            cookie(userSessionCookieName, sessionId, {
                path: "/",
                domain: document.location.hostname
                // to remove if you dont  want session cookie
                //   expires: 1 
            });

        } else {
            cookie(notToMonitorCookieName, 'true', {
                path: "/",
                domain: document.location.hostname
                // to remove if you dont  want session cookie
                //   expires: 1 
            });
        }

        CurrentUserSession.sessionId = sessionId;
        CurrentUserSession.pageUrl = document.location.href;
        CurrentUserSession.userId = userId;
        CurrentUserSession.pageId = Logger.getUUID();
    },
    isValidSession(sessionCreated) {
        var result = true;
        var timeNow = Math.floor((new Date).getTime() / 1000);
        if (timeNow - sessionCreated > this.settings.sessionTTL) {
            result = false;
        }
        return result;
    },
    getLocalData: function (cacheKey) {
        if (cookie(userSessionCookieName)) {
            var eventsList = new Array();
            eventsList = store.get(cacheKey);
            if (eventsList) {
                var eventsToSend = [];

                var dataToSend = {
                    timestamp: Date.now(),
                    sessionId: CurrentUserSession.sessionId,
                    '@events': eventsList
                };

                return dataToSend;
            }
        } else {
            return null;
        }
    },
    getUUID: function () {
        var CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
        var chars = CHARS,
            uuid = new Array(36),
            rnd = 0,
            r;
        for (var i = 0; i < 36; i++) {
            if (i == 8 || i == 13 || i == 18 || i == 23) {
                uuid[i] = '-';
            } else if (i == 14) {
                uuid[i] = '4';
            } else {
                if (rnd <= 0x02) rnd = 0x2000000 + (Math.random() * 0x1000000) | 0;
                r = rnd & 0xf;
                rnd = rnd >> 4;
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
        }
        return uuid.join('');
    },
    toMonitor: function () {
        var $this = this;

        if ($this.settings.debug) {
            return true;
        }
        var currentRandom = Math.random() * 100;
        var result = false;

        if (currentRandom <= 10 && !cookie(userSessionCookieName) && !cookie(notToMonitorCookieName)) {
            result = true;
        }

        console.log('will log: ' + result)
        return result;
    },
    getSessionData: function () {
        return 'sid=' + currentSessionId + '&sc=' + Math.floor((new Date).getTime() / 1000);
    }
}

function S4() { return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1); }
function retargetingGuid() { return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase(); }
export function setRetargetingCookie() {
    if (cookie('cookie_perimpid') == null || cookie('cookie_perimpid') == "undefined") {
        cookie("cookie_perimpid", retargetingGuid(), 3888000000);
    }
    cookie("cookie_impid", retargetingGuid(), 3888000000);
}

export function newEvent(eType) {
    const currentTime = (new Date()).getTime();
    const queries = getQueryStringParams(location.search);
    const sponsorid = queries.wid ? queries.wid / 12345 : 12345;
    const promocode = queries.promocode ? queries.promocode : 'xxx';

    let itemID = location.href.split('/');
    itemID = itemID[itemID.length - 1].split('?')[0];
    const myEvent = new EventItem(currentTime, eType, itemID);
    myEvent.sponsorid = sponsorid;
    myEvent.promocode = promocode;
    myEvent.banner_impression_id = cookie("cookie_impid");
    myEvent.persistentimpressionid = cookie("cookie_perimpid");
    myEvent.iniframe = window.self !== window.top;
    return myEvent;
}

//$(document).ready(function () {

//    // check for js files exists

//    // To start logging errors remove remarks 
//    // window.Logger.startLogErrors();

//    // Set user session pass userId 
//    //window.SQSSender.init(window.SQSSender.environment.pCash);
//    //window.Logger.setCurrentSession('1233211112');
//    //// $('.dhc_container').logImpressions(15000);
//    ////$('.host_container').logImpressions({
//    ////    logInterval: 10000
//    ////});
//    ////$('.host_container').logUserEvents({
//    ////    logInterval: 10000
//    ////});

//    ////$(document).logHeatMap({
//    ////    saveInterval: 100,
//    ////    sendInterval: 5000,
//    ////    logScrollPosition: true
//    ////});

//    //$('.host_container').logClick({
//    //    origiName: 'origin name',
//    //    originId: '1231233333',
//    //    callbackFunction: function () {
//    //        alert('done');
//    //    }
//    //});
//    // For flash implimentation:
//    // 1.
//    // call Logger.saveLocal(*eventItem,** cacheKey)
//    // 2.
//    // Call Logger.sendLog(**cacheKey)  
//    // * one of the instances of objects - look for type above, if needed add a new type 
//    // ** look for CacheKeys enum above, if needed add a new type 



//});